import { APP_ENV, ENV_NAMES } from "@utils/env";
import { PropsWithChildren } from "react";

export const DevOnlyWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return [ENV_NAMES.DEV, ENV_NAMES.LOCAL].includes(APP_ENV) ? <>{children}</> : null;
};

export const StagingAndBelowWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return [ENV_NAMES.DEV, ENV_NAMES.LOCAL, ENV_NAMES.STAGING].includes(APP_ENV) ? <>{children}</> : null;
};
